export enum ItemsGroupByTypeKeys {
    PimsGeneratedId = 'pimsGeneratedId',
    HospitalDescription = 'hospitalDescription',
}
